import React, { useContext } from 'react';
import FaqListTable from '../FaqListTable';
import classNames from 'classnames';
import FaqContext from '../../providers/Faq/Faq.context';
import ResolvePagination from 'components/ResolvePagination';
import FaqEmpty from '../FaqEmpty';

import './PageContent.styles.scss';
import './PageContent.styles.responsive.scss';

type PageContentProps = {
  className?: string;
};

const PageContent: React.FC<PageContentProps> = (props) => {
  const { className } = props;
  const {
    displayedQuestions,
    areQuestionsLoading,
    isFaqAccessLoading,
    totalPages,
  } = useContext(FaqContext);

  const classes = classNames('page-content', 'white-panel', className);

  if (!displayedQuestions.length && !areQuestionsLoading && !isFaqAccessLoading)
    return (
      <div className={classes}>
        <FaqEmpty />
      </div>
    );

  return (
    <div className={classes}>
      <FaqListTable />
      <ResolvePagination totalPages={totalPages} />
    </div>
  );
};

export default PageContent;
